/**
 * O identificador do acesso de suporte em andamento (M17).
 *
 * **O token nunca é guardado**, e isso é deliberado: um token de acesso à conta
 * de terceiro salvo no navegador sobreviveria à janela de trinta minutos que
 * existe justamente para limitá-lo.
 *
 * O que fica guardado é o identificador do acesso — inútil por si só. Para
 * virar token de novo, ele precisa da sessão de plataforma de quem entrou **e**
 * de uma janela ainda aberta, que o servidor reconfere. É o que permite ao
 * suporte apertar F5 sem cair fora do atendimento.
 *
 * Fica no `sessionStorage`, e não no `localStorage`: o acesso morre com a aba,
 * como o atendimento que o originou.
 */
const CHAVE = 'levitas:acesso-de-suporte';

export function lembrarAcessoDeSuporte(id: string): void {
  try {
    sessionStorage.setItem(CHAVE, id);
  } catch {
    // Navegador com armazenamento bloqueado: o suporte perde o acesso ao
    // recarregar, e só. Nada quebra por causa disso.
  }
}

export function acessoDeSuporteLembrado(): string | null {
  try {
    return sessionStorage.getItem(CHAVE);
  } catch {
    return null;
  }
}

export function esquecerAcessoDeSuporte(): void {
  try {
    sessionStorage.removeItem(CHAVE);
  } catch {
    // Ver acima: não há o que fazer, e não há o que quebrar.
  }
}
